export default "__VITE_ASSET__CuVTFNr1__"